<template>
    <div>
        <head-layout title="Update" />

        <div class="text-h2">Update local data</div>

        <v-data-table
            :headers="[
                { text: 'Job', value: 'monitorable_type' },
                { text: 'Status', value: 'status' },
                { text: 'Started At', value: 'created_at' },
            ]"
            :items="$page.props.jobs"
        >
        </v-data-table>

        <div class="d-flex flex-column align-start">
            <v-btn
                v-for="(type, name) in $page.props.types"
                :key="name"
                class="my-8"
                :disabled="disabled(type)"
                @click="updateProducts(type)"
                >Update {{ name }}
            </v-btn>

            <v-btn class="my-8" @click="updateDepartments"
                >Update Departments
            </v-btn>
        </div>
    </div>
</template>

<script>
import HeadLayout from "@/Layouts/HeadLayout";

export default {
    name: "Updates",
    components: { HeadLayout },

    methods: {
        updateProducts(type) {
            this.$inertia.post(this.route("setup.update"), { type: type });
        },

        updateDepartments() {
            this.$inertia.post(this.route("setup.update.departments"));
        },

        disabled(type) {
            return this.$page.props.jobs.some((job) => {
                return job.monitorable_type === type && job.status === 0;
            });
        },
    },
};
</script>

<style scoped></style>
